<template>
    <!-- 耕雲導師解惑录 -->
    <div class="taoist">
        <div v-for="(item,index) in content" :key="index">
            <div class="flex-between title">
                <div class="titleLeft oneLine">{{item.cate_name}}</div>
<!--                <div-->
<!--                    v-show="item.lists.length>3"-->
<!--                    class="expand flex-start"-->
<!--                    @click="changShowList(index)"-->
<!--                >-->
<!--                    &lt;!&ndash; 展开收起按钮 &ndash;&gt;-->
<!--                    <div v-if="!contentStatus[index]" class="flex-center openBtn">-->
<!--                        <div>{{$t('downBtn')}}</div>-->
<!--                        <div class="down">-->
<!--                            <img src="../../static/img/down.png" alt />-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div v-if="contentStatus[index]" class="flex-center openBtn">-->
<!--                        <div>{{$t('upBtn')}}</div>-->
<!--                        <div class="down">-->
<!--                            <img src="../../static/img/up.png" alt />-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </div>

            <!-- 二级列表 -->
          <div>
            <div
                class="content"
                v-for="(item1,index1) in item.lists"
                :key="index1"
                @click="linkToDetail(item1)"
            >{{index1+1}}、{{item1.news_title}}</div>
          </div>
<!--          <div v-else>-->
<!--            <div-->
<!--                class="content"-->
<!--                @click="linkToDetail(item.lists[0])"-->
<!--            >{{1}}、{{item.lists[0].news_title}}</div>-->
<!--            <div-->
<!--                class="content"-->
<!--                @click="linkToDetail(item.lists[1])"-->
<!--            >{{2}}、{{item.lists[1].news_title}}</div>-->
<!--            <point></point>-->
<!--            <div-->
<!--                class="content"-->
<!--                @click="linkToDetail(item.lists[item.lists.length-1])"-->
<!--            >{{item.lists.length}}、{{item.lists[item.lists.length-1].news_title}}</div>-->
<!--          </div>-->
<!--            <div v-if="item.lists.length<=3 || contentStatus[index]">-->
<!--                <div-->
<!--                    class="content"-->
<!--                    v-for="(item1,index1) in item.lists"-->
<!--                    :key="index1"-->
<!--                    @click="linkToDetail(item1)"-->
<!--                >{{index1+1}}、{{item1.news_title}}</div>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--                <div-->
<!--                    class="content"-->
<!--                    @click="linkToDetail(item.lists[0])"-->
<!--                >{{1}}、{{item.lists[0].news_title}}</div>-->
<!--                <div-->
<!--                    class="content"-->
<!--                    @click="linkToDetail(item.lists[1])"-->
<!--                >{{2}}、{{item.lists[1].news_title}}</div>-->
<!--                <point></point>-->
<!--                <div-->
<!--                    class="content"-->
<!--                    @click="linkToDetail(item.lists[item.lists.length-1])"-->
<!--                >{{item.lists.length}}、{{item.lists[item.lists.length-1].news_title}}</div>-->
<!--            </div>-->
            <barF5></barF5>
        </div>
    </div>
</template>

<script>
import point from "../../components/point";
import barF5 from "../../components/barF5";
export default {
    name: "",
    components: {
        point,
        barF5
    },
    props: {
        content: {
            type: Array,
            default: () => []
        },
        title:{
            type:String,
            default:() => []
        }
    },
    data() {
        return {
            contentStatus: [false, false, false] //控制展开和结束
            // content: [{
            //     title: "耕雲導師解惑录",
            //     list: ['邁向生命的圓滿', '禪的認知與修學', '談心', '禪的認知與修學', '禪的認知與修學', '禪的認知與修學']
            //   },
            //   {
            //     title: "耕雲導師解惑录",
            //     list: [11, 22]
            //   },
            //   {
            //     title: "耕雲導師解惑录",
            //     list: ['邁向生命的圓滿', '中華禪風的演變', '參學正眼', '無漏行', '佛法在世間']
            //   }
            // ]
        };
    },
    watch:{
        content(){
             //初始化contentStatus
            let array = [];
            let length = this.content.length;
            for(let i=0;i<length;i++){
                array[i] = false;
            }
            this.contentStatus = array;
        }
    },
    methods: {
        changShowList(index) {
            this.contentStatus.splice(index, 1, !this.contentStatus[index]);
        },
        //文章详情
        linkToDetail(item) {
            this.$router.push({
                path: "/articleDetail",
                query: { name: "puzzle", id: item.id,title:this.title }
            });
        }
    }
};
</script>

<style scoped>
.taoist {
    color: #333333;
}

.title {
    padding: 0.64rem;
}

.titleLeft {
    font-size: 0.85rem;
    line-height: 1.8rem;
    font-weight: 600;
    width: 12rem;
}

.content {
    font-size: 0.85rem;
    /* height: 2.4rem; */
    border-top: 1px dashed #dfdfdf;
    line-height: 1.8rem;
    padding-left: 0.64rem;
    padding-right: 0.64rem;
}

/* .expand {
    font-size: 0.69rem;
    width: 3.6rem;
  } */
.openBtn {
    width: 4rem;
   flex-shrink:0;
}
.down img {
    width: 0.64rem;
    height: 0.32rem;
    margin-left: 0.2rem;
}
</style>